import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuInputRangeDimensions } from '../../SbSharedRefineMenu/SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRangeDimensions.tsx';

import { type SbRespRefineMenuFilterDimensions_itemSearch$key } from './__generated__/SbRespRefineMenuFilterDimensions_itemSearch.graphql.ts';
import { type SbRespRefineMenuFilterDimensions_filters$key } from './__generated__/SbRespRefineMenuFilterDimensions_filters.graphql.ts';
import { type SbRespRefineMenuFilterDimensions_user$key } from './__generated__/SbRespRefineMenuFilterDimensions_user.graphql.ts';

const itemSearchFragment = graphql`
    fragment SbRespRefineMenuFilterDimensions_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuInputRangeDimensions_itemSearch
    }
`;
const filtersFragment = graphql`
    fragment SbRespRefineMenuFilterDimensions_filters on SearchBrowseFilter @relay(plural: true) {
        ...SbSharedRefineMenuInputRangeDimensions_filters
    }
`;
const userFragment = graphql`
    fragment SbRespRefineMenuFilterDimensions_user on User {
        ...SbSharedRefineMenuInputRangeDimensions_user
    }
`;

type Props = {
    itemSearch: SbRespRefineMenuFilterDimensions_itemSearch$key;
    filters: SbRespRefineMenuFilterDimensions_filters$key;
    user: SbRespRefineMenuFilterDimensions_user$key;
    applyOnBlur?: boolean;
    trackingOptions?: Record<string, unknown>;
};

export const SbRespRefineMenuFilterDimensions: FC<Props> = ({
    itemSearch: itemSearchRef,
    filters: filtersRef,
    user: userRef,
    applyOnBlur,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const filters = useFragment(filtersFragment, filtersRef);
    const user = useFragment(userFragment, userRef);
    return (
        <SbSharedRefineMenuInputRangeDimensions
            itemSearch={itemSearch}
            filters={filters}
            user={user}
            applyOnBlur={applyOnBlur}
            size="medium"
            showInvalidRangeErrorMessage={false}
            trackingOptions={trackingOptions}
        />
    );
};
